import React, { Component } from "react";
import ChatStatus from "./ChatStatus";
import DoctorNotes from "./DoctorNotes";
import ProfileImage from "./ProfileImage";
import Toolbar from "./Toolbar";
import Spinner from "react-bootstrap/Spinner";
import { useAsync } from "react-async";
import { MediaModal } from "./MediaModal";
import moment from "moment";
import { getPatientName } from "helpers/teleconsult.helper";
import InfiniteScroll from "react-infinite-scroll-component";
import ScheduleFollowUpModal from "../Appointments/ScheduleFollowUpModal";

export class TwilioConversation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      conversation_loading: false,
      messagesProxy: [],
      showMediaModal: false,
      currentMedia: null,
      newMessage: "",
      loadingState: "ready",
      messagesByGroup: [],
      countdown: 0,
      selectedFile: "",
      conversationMsgsProxy: {},
    };

    this.toggleMediaModal = this.toggleMediaModal.bind(this);
    this.messagesEndRef = React.createRef();
  }

  toggleMediaModal = (toggle, media = null) =>
    this.setState({ showMediaModal: toggle, currentMedia: media });

  componentDidMount() {
    if (this.props.messages) {
      this.scrollToBottom();
      this.setState(
        {
          messagesProxy: this.props.messages,
          conversationMsgsProxy: this.props.conversationMsgs,
        },
        () => {
          this.updateMessagesProxy();
        }
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.chat !== prevProps.chat) {
      this.setState({
        messagesByGroup: [],
      });
    }
    if (this.props.messages && this.props.messages !== prevProps.messages) {
      this.setState(
        {
          messagesProxy: this.props.messages,
        },
        () => {
          this.updateMessagesProxy();
        }
      );
    }
  }

  updateMessagesProxy(bottomScroll = true) {
    let messagesByGroup = this.state.messagesByGroup;
    this.state.messagesProxy.forEach((msg) => {
      let temp_date = moment(msg.dateCreated).format("YYYY-MM-DD");
      let date = moment(msg.dateCreated).format("DD/MM/YYYY");
      if (date === moment().format("DD/MM/YYYY")) {
        date = "Today";
      }
      let index = messagesByGroup.findIndex((e) => e.date === date);
      if (index !== -1) {
        let finding = messagesByGroup[index].messages.findIndex(
          (e) => e.sid === msg.sid
        );
        if (finding === -1) {
          messagesByGroup[index].messages.push(msg);
        }
      } else {
        messagesByGroup.push({
          date: date,
          temp_date: temp_date,
          messages: [msg],
        });
      }
    });
    this.setState(
      {
        messagesByGroup: messagesByGroup.sort(
          (a, b) => Date.parse(b.temp_date) - Date.parse(a.temp_date)
        ),
      },
      () => {
        if (bottomScroll) {
          setTimeout(() => {
            this.scrollToBottom();
          }, 500);
        }
      }
    );
  }

  isAuthor(identity) {
    return identity.includes("Doctor-");
  }
  onMessageChanged = (event) => {
    this.setState({ newMessage: event.target.value });
  };

  checkChatSession(chat_props) {
    let isChatSessionEnded = false;
    if (chat_props && chat_props.end_at) {
      isChatSessionEnded = chat_props.server_current_time >= chat_props.end_at;
    }
    return isChatSessionEnded;
  }

  uploadMedia(e) {
    if (e.target.files.length >= 1) {
      let file = e.target.files[0];

      if (!file.type.includes("image/")) {
        alert("Only image is allow to be uploaded");
        return;
      }
      if (file.size > 2000000) {
        alert("File size cannot exceed more than 2MB");
        return;
      }
    } else {
      this.setState({ selectedFile: "" });
    }
  }

  scrollToBottom = () => {
    if (this.messagesEndRef.current)
      this.messagesEndRef.current.scrollTop =
        this.messagesEndRef.current.scrollHeight;
  };

  fetchMoreData = () => {
    this.state.conversationMsgsProxy
      .prevPage()
      .then((res) => {
        this.setState(
          {
            messagesProxy: res.items.concat(this.state.messagesProxy),
            conversationMsgsProxy: res,
          },
          () => {
            this.updateMessagesProxy(false);
          }
        );
      })
      .catch((err) => {
        console.log("err = ", err);
      });
  };

  render() {
    const getMedia = async ({ media }) => {
      const res = await media.getContentTemporaryUrl();
      return res;
    };

    const Media = ({ media }) => {
      const { data, error, isLoading } = useAsync({
        promiseFn: getMedia,
        media,
      });
      if (isLoading)
        return (
          <div className="loader">
            <Spinner animation="border" className="spinner" />
          </div>
        );
      if (error) return error;
      if (data) {
        return (
          <button
            className="btn btn-link p-0"
            onClick={() => this.toggleMediaModal(true, data)}
          >
            <img className="media" src={data} alt="media-message" />
          </button>
        );
      }
      return null;
    };

    return (
      <div className="conversation">
        <div className="conversation-header">
          <div className="chat-img">
            <ProfileImage chat={this.props.chat} />
          </div>
          <div className="chat-info">
            <div>
              <div className="name">{getPatientName(this.props.chat)}</div>
              <ChatStatus
                chat={this.props.chat}
                checkChatSession={this.checkChatSession(this.props.chat)}
              />
            </div>
            {(this.props.chat.video_session ||
              this.props.chat.is_premium_plus) && (
              <>
                <ScheduleFollowUpModal details={this.props.chat} />
              </>
            )}
          </div>
        </div>
        <div className="conversation-body">
          <div
            className="conversation-box scrollbar-grey"
            ref={this.messagesEndRef}
            id="conversation-box"
          >
            <InfiniteScroll
              dataLength={this.state.messagesProxy.length}
              next={this.fetchMoreData}
              style={{ display: "flex", flexDirection: "column-reverse" }} //To put endMessage and loader to the top.
              hasMore={this.state.conversationMsgsProxy.hasPrevPage}
              loader={
                <small className="text-center">
                  <Spinner animation="border" className="spinner" />
                </small>
              }
              endMessage={
                <small className="text-center">
                  Start of the conversation.
                </small>
              }
              inverse={true}
              scrollableTarget="conversation-box"
              className="scrollbar-grey"
            >
              {this.state.messagesByGroup.map((group, group_index) => (
                <div key={`message-group-${group_index}`}>
                  <div className="msg-date">{group.date}</div>
                  <div>
                    {group.messages
                      .sort((a, b) => (a.dateCreated < b.dateCreated ? -1 : 1))
                      .map((msg, index) => (
                        <div
                          key={`message-${index}`}
                          className={`message-row ${
                            this.isAuthor(msg.state.author)
                              ? "by-author"
                              : "by-opposite"
                          }`}
                        >
                          <div className="message">
                            {msg.state.type === "media" ? (
                              <Media media={msg.state.media} />
                            ) : (
                              <span>{msg.state.body}</span>
                            )}
                            <div className="timestamp text-nowrap">
                              <small>
                                {moment(
                                  msg.dateCreated,
                                  "DD/MM/YYYY HH:mm:ss"
                                ).format("hh:mm A")}
                              </small>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </InfiniteScroll>
          </div>
          <Toolbar
            props={this.props}
            checkChatSession={this.checkChatSession}
            loadingState={this.state.loadingState}
          />
          <DoctorNotes chat={this.props.chat} />
        </div>

        <MediaModal
          toggleMediaModal={this.toggleMediaModal}
          show={this.state.showMediaModal}
          media={this.state.currentMedia}
        />
      </div>
    );
  }
}
